import React, { Component } from "react";
import { translate } from "react-polyglot";
import Select from "react-select";
import { ValueType } from "react-select/lib/types";
import { Col, Input, Row } from "reactstrap";
import styled from "styled-components";
import filterOperators from "../../helpers/filterOperators";
import CustomButton from "../helpers/CustomButton";
import * as operators from "./operators";

const HeightInput = styled(Input)`
  height: 2.375rem !important;
`;

interface IOption {
  label: string;
  value: string;
}

interface IParameter {
  label: string;
  value: string;
  type: string;
}

interface IFilter {
  id: string;
  parameter: string;
  operator: string;
  values: string[];
}

const Flexbox = styled.div`
  display: flex;
`;

const FlexChildSmall = styled.div`
  flex-basis: fit-content;
  padding: 0.25rem;
`;

const FlexChildLarge = styled.div`
  flex-grow: 2;
  padding: 0.25rem;
`;

const ResponsiveSelect = styled(Select)`
  width: ${props => props.width}rem !important;
`;

interface IProps {
  parameterList: IParameter[];
  isLast: boolean;
  filter: IFilter;
  handleParameterChange: (
    filterId: string,
    parameter: string,
    type: string
  ) => void;
  handleOperatorChange: (filterId: string, option: string) => void;
  handleValueChange: (filterId: string, value: string[]) => void;
  removeFilter: (filterId: string) => void;
}

class DesktopFilter extends Component<IProps & TranslateProps> {
  public state = { value1: "", value2: "" };
  constructor(props: IProps & TranslateProps) {
    super(props);
  }

  public handleMultipleValues(
    filterId: string,
    value: string,
    valueNumber: number
  ) {
    const { handleValueChange } = this.props;
    if (valueNumber === 1) {
      this.setState({ value1: value }, () => {
        handleValueChange(filterId, [this.state.value1, this.state.value2]);
      });
      return;
    }
    if (valueNumber === 2) {
      this.setState({ value2: value }, () => {
        handleValueChange(filterId, [this.state.value1, this.state.value2]);
      });
      return;
    }
  }

  public render() {
    const {
      parameterList,
      t,
      filter,
      handleOperatorChange,
      handleParameterChange,
      handleValueChange,
      removeFilter
    } = this.props;
    const { id, parameter, operator, values } = filter;

    const { type: paramType, value: paramValue } = parameterList.find(
      p => p.value === parameter
    );

    const operatorList = filterOperators(paramType).map(o => {
      return {
        label: t(`operators.${o}`),
        value: o
      };
    });
    const selectedOperator = operatorList.find(o => o.value === operator);
    const paramWidth = 1 * paramValue.length;
    const operatorWidth =
      1 * (selectedOperator ? selectedOperator.value.length : 10);

    return (
      <Row className="pt-1 pb-1">
        <Col>
          <Flexbox>
            <FlexChildSmall>
              <ResponsiveSelect
                width={paramWidth}
                name="parameters"
                options={parameterList}
                onChange={(option: IParameter) =>
                  handleParameterChange(id, option.value, option.type)
                }
                value={parameterList.find(p => p.value === parameter)}
              />
            </FlexChildSmall>

            <FlexChildSmall>
              <ResponsiveSelect
                name="operators"
                width={operatorWidth}
                options={operatorList}
                onChange={(option: ValueType<IOption>) =>
                  handleOperatorChange(id, (option as IOption).value)
                }
                isMulti={false}
                value={operatorList.find(o => o.value === operator)}
              />
            </FlexChildSmall>

            {operator === operators.BETWEEN ||
            operator === operators.NOT_BETWEEN ? (
              <React.Fragment>
                <FlexChildSmall>
                  <HeightInput
                    type="number"
                    onChange={e =>
                      this.handleMultipleValues(id, e.target.value, 1)
                    }
                    value={values[0]}
                  />
                </FlexChildSmall>

                <FlexChildSmall>
                  <HeightInput disabled={true} value="AND" />
                </FlexChildSmall>

                <FlexChildSmall>
                  <HeightInput
                    type="number"
                    onChange={e =>
                      this.handleMultipleValues(id, e.target.value, 2)
                    }
                    value={values[1] || ""}
                  />
                </FlexChildSmall>
              </React.Fragment>
            ) : (
              <FlexChildLarge>
                <HeightInput
                  onChange={e => handleValueChange(id, [e.target.value])}
                  value={values[0]}
                  type={paramType === "string" ? "text" : "number"}
                />
              </FlexChildLarge>
            )}

            <FlexChildSmall>
              <CustomButton
                isCircle={true}
                className="shadow-none"
                color="danger"
                onClick={() => removeFilter(id)}
              >
                <i className="fas fa-trash" />
              </CustomButton>
            </FlexChildSmall>
          </Flexbox>
        </Col>
      </Row>
    );
  }
}

export default translate()(DesktopFilter);
